import { Navigate, Route, Routes } from 'react-router-dom'

import { links, paths } from 'apps'
import { CommonLayout } from 'layouts'
import { PrivateRoute } from 'routes'
import { HorseMain, HorseDetail, HorseDetailRaceView } from './pages'
import { useAppSelector } from 'hooks'

function Horse() {
  const auth = useAppSelector(state => state.auth)
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseMain />
          </PrivateRoute>
        }
      />
      <Route
        path={paths.horse.detail()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={paths.horse.detailByToken()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseDetail />
          </PrivateRoute>
        }
      />
      <Route
        path={paths.horse.detailRaceView()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <HorseDetailRaceView />
          </PrivateRoute>
        }
      />
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}

export default Horse
